import { InstanceScreen } from 'component/navigation/instance';

export default function ModerationDashboardReviewScreen() {
    return <InstanceScreen screenKey='review' />;
}
